import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BuilderChatOnboardingContainer } from '../BuilderChatOnboardingContainer';
import { forceBuilderOnboardingClosing } from 'shared/actions/chatOnboarding';
import { useBuilderChatButtonContextValue, useBuilderChatOpenHandler } from 'shared/hooks/builderChats';
import { getBuilderChatEnabled } from 'shared/selectors/newbuildingHeader';

export const NewbuildingLayoutChatButtonContainer: React.FC = () => {
  const isChatEnabled = useSelector(getBuilderChatEnabled);
  const chatButtonContextValue = useBuilderChatButtonContextValue();
  const openChat = useBuilderChatOpenHandler({
    placeType: 'Open_layout_modal_block',
  });

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(forceBuilderOnboardingClosing('layoutModal'));
  }, [dispatch]);

  if (!isChatEnabled) {
    return null;
  }

  return (
    <BuilderChatOnboardingContainer type="layoutModal" placement="left-start">
      <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
        <CianNewbuildingChatButton
          onClick={handleButtonClick}
          onChatOpen={openChat}
          size="M"
          theme="fill_secondary"
          fullWidth
          beforeIcon={<IconCommunicationMessage16 color="current_color" />}
        >
          Написать
        </CianNewbuildingChatButton>
      </CianNewbuildingChatButtonContext.Provider>
    </BuilderChatOnboardingContainer>
  );
};
